export function convertRhinoErrorToTvpil(error: any) {
  if (error.code === 'NETWORK_ERROR') {
    error.code = 'client::request-network-error';
  }
}
